// FastAPI hata gövdelerini her zaman okunabilir tek bir metne çevirir.
//
// Neden gerekli: doğrulama hatalarında (422) FastAPI `detail` alanını bir
// **dizi** olarak döner —
//   {"detail": [{"type": "string_too_short", "loc": ["body", "password"], ...}]}
// Bu dizi doğrudan bir toast'a / JSX'e verilirse React
// "Objects are not valid as a React child" hatası fırlatır, ağaç çöker ve
// kullanıcı bunu bomboş (siyah) ekran olarak görür. Bu yüzden `detail`
// arayüze ulaşmadan önce burada metne indirgenir.

// Doğrulama hatasındaki alan adlarının kullanıcıya gösterilen karşılıkları.
const FIELD_LABELS = {
  username: 'Kullanıcı adı',
  password: 'Şifre',
  email: 'E-posta',
  phone: 'Telefon',
  first_name: 'Ad',
  last_name: 'Soyad',
  tc_no: 'T.C. kimlik numarası',
  birth_date: 'Doğum tarihi',
  city: 'Şehir',
  code: 'Doğrulama kodu',
  challenge: 'Doğrulama oturumu',
  token: 'Bağlantı',
  amount: 'Tutar',
  method_id: 'Ödeme yöntemi',
  method_name: 'Ödeme yöntemi',
  iban: 'IBAN',
  wallet_address: 'Cüzdan adresi',
};

// `loc` gövdenin neresinde hata olduğunu söyler: ['body', 'password'].
// Taşıyıcı adlarını atıp gerçek alan adını buluruz.
const CARRIER_KEYS = new Set(['body', 'query', 'path', 'header', 'cookie']);

const fieldLabel = (loc) => {
  if (!Array.isArray(loc)) return '';
  const field = [...loc]
    .reverse()
    .find((part) => typeof part === 'string' && !CARRIER_KEYS.has(part));
  if (!field) return '';
  return FIELD_LABELS[field] || field;
};

// Pydantic v2 hata tiplerinin Türkçe karşılıkları. Listede olmayan tipler
// genel bir "geçersiz" mesajına düşer — mesaj kaybolmaz, sadece genelleşir.
const ruleMessage = (item) => {
  const ctx = item?.ctx || {};
  switch (item?.type) {
    case 'missing':
      return 'zorunludur';
    case 'string_too_short':
    case 'too_short':
      return `en az ${ctx.min_length} karakter olmalıdır`;
    case 'string_too_long':
    case 'too_long':
      return `en fazla ${ctx.max_length} karakter olabilir`;
    case 'string_pattern_mismatch':
      return 'biçimi geçersiz';
    case 'greater_than':
      return `${ctx.gt} değerinden büyük olmalıdır`;
    case 'greater_than_equal':
      return `en az ${ctx.ge} olmalıdır`;
    case 'less_than':
      return `${ctx.lt} değerinden küçük olmalıdır`;
    case 'less_than_equal':
      return `en fazla ${ctx.le} olabilir`;
    default:
      return 'geçersiz';
  }
};

const validationMessage = (item) => {
  if (typeof item === 'string') return item.trim();
  if (!item || typeof item !== 'object') return '';
  const label = fieldLabel(item.loc);
  const rule = ruleMessage(item);
  return label ? `${label} ${rule}.` : `Gönderilen bilgi ${rule}.`;
};

/**
 * `detail` alanını — string, dizi ya da nesne olsun — tek bir metne çevirir.
 * Anlamlı bir şey çıkaramazsa boş metin döner; çağıran tarafın kendi
 * yedek mesajını kullanmasına izin verir.
 */
export const detailMessage = (detail) => {
  if (typeof detail === 'string') return detail.trim();
  if (Array.isArray(detail)) {
    return detail.map(validationMessage).filter(Boolean).join(' ');
  }
  if (detail && typeof detail === 'object') {
    const direct = detail.message || detail.msg || detail.error;
    if (typeof direct === 'string') return direct.trim();
    return validationMessage(detail);
  }
  return '';
};

/** Axios hatasından kullanıcıya gösterilebilir mesajı üretir. */
export const apiErrorMessage = (error, fallback = 'Bir hata oluştu') => (
  detailMessage(error?.response?.data?.detail) || fallback
);

export default apiErrorMessage;
